import { connect } from 'react-redux';
import { loadCsvReportDataAction } from '../../../../reducers/reports.reducers';
import PdfVisualizer from './pdf-visualizer';


const mapStateToProps = state => ({
  supportsCsvExport: state.reports.pdfSupportsCsvExport,
  isLoadingCsvExport: state.reports.isLoadingCsvReportData,
});

const mapDispatchToProps = dispatch => ({
  downloadCsvReportData: dto => dispatch(loadCsvReportDataAction.INIT(dto)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PdfVisualizer);
